<template>
    <div>
        <v-card outlined v-if="template" class="auto-message-summary-card">
            <v-card-text class="py-2">
                <div v-if="show_label" class="d-flex align-start justify-space-between my-3">
                    <dl class="detail-item mb-0">
                        <dt class="text-caption grey--text font-weight-light text--darken-1 mb-0">Label</dt>
                        <dd class="text-subtitle-1 font-weight-medium mb-0">{{ template.template_label }}</dd>
                    </dl>
                </div>
    
                <v-row dense class="mt-1 mb-0">
                    <v-col cols="12" sm="6" md="5">
                        <dl class="detail-item">
                            <dt class="text-caption grey--text font-weight-light text--darken-1 mb-0">Send From Phone Number</dt>
                            <dd class="text-body-2 mb-0" :class="template.send_from ? '' : 'error--text font-weight-bold'">
                                {{ pretty_send_from }}
                            </dd>
                        </dl>
                    </v-col>
    
                    <v-col cols="12" sm="6" md="3">
                        <dl class="detail-item">
                            <dt class="text-caption grey--text font-weight-light text--darken-1 mb-0">Mode</dt>
                            <dd class="mb-0">
                                <v-chip
                                    :color="mode_chip_color"
                                    text-color="white"
                                    small
                                    :aria-label="`Mode: ${template.comp_best_send_mode}`"
                                >
                                    <v-icon small left aria-hidden="true">
                                        {{ mode_icon }}
                                    </v-icon>
                                    {{ template.comp_best_send_mode.charAt(0).toUpperCase() + template.comp_best_send_mode.slice(1).toLowerCase() }}
                                </v-chip>
                            </dd>
                        </dl>
                    </v-col>
    
                    <v-col v-if="order_conf_linkage_status" cols="12" md="4">
                        <dl class="detail-item">
                            <dt class="text-caption grey--text font-weight-light text--darken-1 mb-0">Order Confirmation Form</dt>
                            <dd class="mb-0">
                                <v-chip
                                    :color="order_conf_linkage_status.color"
                                    text-color="white"
                                    small
                                    :aria-label="`Order confirmation form: ${order_conf_linkage_status.label}`"
                                >
                                    <v-icon small left aria-hidden="true">
                                        {{ order_conf_linkage_status.icon }}
                                    </v-icon>
                                    {{ order_conf_linkage_status.label }}
                                </v-chip>
                            </dd>
                        </dl>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    
        <v-row v-if="has_issues" dense class="mt-1 mb-0">
            <v-col cols="12">
                <v-alert
                    color="info"
                    class="mb-0"
                    dense
                    text
                >
                    <div class="d-flex align-center gap-2 mb-1">
                        <v-icon aria-hidden="true" size="20">mdi-information</v-icon>
                        <div class="text-body-overline font-weight-medium">Send Notes</div>
                    </div>
                    <ul class="pl-6 mb-0 text-body-2">
                        <li
                            v-for="(note, index) in all_notes"
                            :key="index"
                            class="mb-1"
                        >
                            {{ note }}
                        </li>
                    </ul>
                </v-alert>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import AutoMessageDisplayHelpers from '@/mixins/auto-messages/summary-display-helpers.js';

export default {
    name: 'AutoMessageSummaryCard',

    mixins: [AutoMessageDisplayHelpers],

    props: {
        template: {
            type: Object,
            required: true,
        },

        show_label: {
            type: Boolean,
            default: true,
        },

        /**
         * If provided, used to determine order confirmation linkage status
         * with respect to this order confirmation settings ID.
         */
        context_order_conf_settings_id: {
            type: String,
            default: null,
        },
    },

    computed: {
        pretty_send_from() {
            return this.autoMessagePrettySendFrom(this.template);
        },

        mode_chip_color() {
            return this.autoMessageGetModeChipColor(this.template.comp_best_send_mode);
        },

        mode_icon() {
            return this.autoMessageGetModeIcon(this.template.comp_best_send_mode);
        },

        has_issues() {
            return this.autoMessageHasIssues(this.template);
        },

        all_notes() {
            return this.autoMessageGetAllNotes(this.template, this.context_order_conf_settings_id);
        },

        order_conf_linkage_status() {
            return this.autoMessageGetOrderConfLinkageStatus(this.template, this.context_order_conf_settings_id);
        },
    },
};
</script>

<style lang="scss" scoped>
.auto-message-summary-card {
    dl.detail-item {
        margin: 0;
        min-height: 52px;
    }

    dd {
        margin-left: 0;
    }
}
</style>
